import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import App from './App.vue';
import { AuthenticationMiddleware, LoginMiddleware, LogoutMiddleware } from '@/middlewares';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: App,
    meta: {
      middlewares: [LoginMiddleware, AuthenticationMiddleware],
    },
    children: [],
  }, {
    path: '/login',
    name: 'public',
    component: App,
    meta: {
      middlewares: [LogoutMiddleware],
    },
    children: [],
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

export function registerModuleRoutes(newRoutes: RouteRecordRaw[], parentName = 'home') {
  for (const route of newRoutes) {
    router.addRoute(parentName, route);
  }
}

export default router;
